<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Sarabun:wght@400;600&display=swap");

#app {
  font-family: "Sarabun", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.swal2-container {
  font-family: "Sarabun", -apple-system, Helvetica, Arial, sans-serif !important;
}
.swal2-actions button {
  color: #fff;
}
</style>
